


import { supabase } from "../../../../supabaseClient.js";



export async function insertarDetalleVenta({ id_venta, detalle }) {
  const { error } = await supabase
    .from("detalle_ventas")
    .insert({
      ...detalle,
      id_venta,
    });

  if (error) throw error;
}
